// extracted by mini-css-extract-plugin
export default {"period":"week_period-module___period___c49606e8","periodLabel":"week_period-module___periodLabel___cec2223e","periodText":"week_period-module___periodText___f125d0f0"};